import { connect } from 'react-redux'
import ArchivedFiles from './archived-files'
import { fetchArchivedFiles } from '../../../../stores/archived-files/archived-files.actions'
import {
  getFetchArchivedFilesRequest,
  getArchivedFiles
} from '../../../../stores/archived-files/archived-files.selectors'

const mapStateToProps = state => {
  const fetchArchivedFilesRequest = getFetchArchivedFilesRequest(state)
  const files = getArchivedFiles(state)
  return {
    noFiles: files && !files.result.length,
    pending: !files || fetchArchivedFilesRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    return dispatch(fetchArchivedFiles())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArchivedFiles)
